import { HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ModalErrorComponent} from '../../components/modal-error/modal-error.component';
import {HttpErrorCodes} from '../../enums/http-error-codes';
import {NxDialogService} from '@aposin/ng-aquila/modal';

export enum SendTypes {
  UPLOAD,
  FORM,
}

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private dialogService: NxDialogService) {}

  showError(err: HttpErrorResponse, type: SendTypes = SendTypes.FORM) {
    this.dialogService.closeAll();
    this.dialogService.open(ModalErrorComponent, {
      data: this.getTextOnErrorCode(err, type),
      showCloseIcon: true,
      autoFocus: true,
    });
  }

  getTextOnErrorCode(err: HttpErrorResponse, type: SendTypes) {
    const obj = this.getTextError(err, type);
    return {
      title: type === SendTypes.UPLOAD ? 'error.upload.title' : 'error.form.title',
      ...obj,
    };
  }

  getTextError(err: HttpErrorResponse, type: SendTypes) {
    const {status, message} = err;
    console.warn(status, HttpErrorCodes[status]);
    const errorNum = HttpErrorCodes[status] ? status + (message ? '_message' : '') : 'notDefined';

    return {text: 'error.httpStatus.' + errorNum, message};
  }
}
